import { GraphicalElement } from "./GraphicalElement";
import { ElementType } from "../../dom-tools/ElementType";
import { HTMLGradient, LinearGradient } from "../basics/Gradient";
import { HTMLColor } from "../../colors/HTMLColor";
import { Property } from "../../events/Property";
import { isClassOf } from "../../tools/TypeUtilities";
import { UIProperty } from "../basics/UIProperty";
import { HSLColor } from "../../colors/HSLColor";

export class Rectangle extends GraphicalElement
{
  static readonly elementType = new ElementType( "ui--rectangle" );

  readonly background   = new UIProperty<string|HTMLGradient|HTMLColor>( this,"white" );
  readonly borderRadius = new UIProperty<number>( this, 0 );


  withBackground( background:string|HTMLGradient|HTMLColor )
  {
    this.background.value = background;

    return this;
  }
  
  constructor()
  {
    super();
    this._setElement( Rectangle.elementType.create() );

    
    this.borderRadius.addListener(
      ()=>
      {
        this.style.borderRadius = this.borderRadius.value + "px";
      }
    );
    
    this.background.addListener(
      ()=>
      {
        let bgValue = this.background.value;
        let stringValue = "";

        console.log( "BACKGROUND VALUE:", bgValue, stringValue );

        if ( typeof bgValue === "string" )
        {
          stringValue = bgValue as string;
        }
        else
        {
          let obj = bgValue as object;
          stringValue = obj.toString();
        }

        console.log( "BACKGROUND VALUE:", bgValue, stringValue );


        this.style.background = stringValue;
      }
    );

    //this.background.value = LinearGradient.createVertical( new HSLColor( 0, 0, 40 ) );
  }

}